// eslint-disable-next-line import/prefer-default-export
export const getZipForDisplay = (zip = '') => {
  return zip?.length === 9 ? `${zip.slice(0, 5)}-${zip.slice(5, 9)}` : zip;
};
